import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
  static targets = [
    "panel",
    "calendarSection",
    "calendarContainer",
    "rangeInput",
    "fromInput",
    "toInput",
  ];

  connect() {
    // Create a hidden input inside the calendar container — flatpickr requires
    // an <input> target. With inline:true it renders the calendar right after it.
    this._fpInput = document.createElement("input");
    this._fpInput.type = "text";
    this._fpInput.hidden = true;
    this.calendarContainerTarget.appendChild(this._fpInput);

    this._fp = flatpickr(this._fpInput, {
      mode: "range",
      inline: true,
      dateFormat: "Y-m-d",
      maxDate: "today",
      defaultDate: this._defaultDates(),
      onChange: (dates) => {
        if (dates.length === 2) {
          this.fromInputTarget.value = this._fp.formatDate(dates[0], "Y-m-d");
          this.toInputTarget.value = this._fp.formatDate(dates[1], "Y-m-d");
          this.rangeInputTarget.value = "custom";
          this.close();
          this.element.requestSubmit();
        }
      },
    });

    this._onClickOutside = (e) => {
      if (!this.element.contains(e.target)) this.close();
    };
    document.addEventListener("click", this._onClickOutside);
  }

  disconnect() {
    this._fp?.destroy();
    this._fpInput?.remove();
    document.removeEventListener("click", this._onClickOutside);
  }

  toggle() {
    this.panelTarget.classList.toggle("hidden");
  }

  close() {
    this.panelTarget.classList.add("hidden");
  }

  selectRange(event) {
    const range = event.currentTarget.dataset.range;
    if (range === "custom") {
      this.calendarSectionTarget.classList.remove("hidden");
    } else {
      this.rangeInputTarget.value = range;
      this.fromInputTarget.value = "";
      this.toInputTarget.value = "";
      this.close();
      this.element.requestSubmit();
    }
  }

  _defaultDates() {
    const from = this.fromInputTarget.value;
    const to = this.toInputTarget.value;
    return from && to ? [from, to] : null;
  }
}
